import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CallRoom, OnlineUser } from './calls-types';

export interface CallTokenResponse {
    token: string;
    url: string;
    roomName: string;
}

export interface CallRoomsResponse {
    items: CallRoom[];
    meta?: { totalItems: number; itemCount: number; currentPage: number; itemsPerPage: number; totalPage: number };
}

@Injectable({
    providedIn: 'root',
})
export class CallsService {
    private readonly enterRoomRequests = new Subject<CallRoom>();

    /** Pedidos para o widget global de chamadas entrar numa sala (ex.: teleatendimento aberto no modal) */
    readonly enterRoomRequested$ = this.enterRoomRequests.asObservable();

    constructor(private readonly http: HttpClient) {}

    requestEnterRoom(room: CallRoom): void {
        this.enterRoomRequests.next(room);
    }

    getOnlineUsers(): Observable<OnlineUser[]> {
        return this.http.get<OnlineUser[]>(`${environment.apiUrl}/call/online-users`);
    }

    getRooms(params?: { company_id?: number; limit?: number | string; page?: number }): Observable<CallRoom[]> {
        let httpParams = new HttpParams();
        if (params?.company_id != null) httpParams = httpParams.set('company_id', String(params.company_id));
        if (params?.limit != null) httpParams = httpParams.set('limit', String(params.limit));
        if (params?.page != null) httpParams = httpParams.set('page', String(params.page));
        return this.http
            .get<CallRoomsResponse | CallRoom[]>(`${environment.apiUrl}/call/rooms`, { params: httpParams })
            .pipe(map((data) => (Array.isArray(data) ? data : (data as CallRoomsResponse).items ?? [])));
    }

    getCallToken(roomId: string): Observable<CallTokenResponse> {
        return this.http.post<CallTokenResponse>(`${environment.apiUrl}/call/token`, { roomId });
    }

    joinRoom(callRoomId: string): Observable<void> {
        return this.http.post<void>(`${environment.apiUrl}/call/rooms/${callRoomId}/join`, {});
    }

    leaveRoom(callRoomId: string): Observable<{ lastParticipant?: boolean; roomFinished?: boolean }> {
        return this.http.post<{ lastParticipant?: boolean; roomFinished?: boolean }>(
            `${environment.apiUrl}/call/rooms/${callRoomId}/leave`,
            {},
        );
    }
}

